import "../style/profile.css";

import React from "react";
import { useParams } from "react-router-dom";
import Profile from "../js/components/profile/Profile.react";

export default function ProfilePage() {
  const { userId } = useParams();
  return <Profile userId={userId} />;
}
